import { render, staticRenderFns } from "./serveManage.vue?vue&type=template&id=34d45bc1&scoped=true"
import script from "./serveManage.js?vue&type=script&lang=js&external"
export * from "./serveManage.js?vue&type=script&lang=js&external"
import style0 from "./serveManage.vue?vue&type=style&index=0&id=34d45bc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d45bc1",
  null
  
)

export default component.exports